var window=global;var $CLJS=require("./cljs_env.js");
'use strict';var wia=require("moment-timezone");module.exports=wia;